import { Component, OnInit } from '@angular/core';
import { ShoopingService } from '../shooping.service';
import { Products } from '../shooping.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';
import { ActivatedRoute } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DataShareService } from '../cart.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {
  products: Products;
  favProduct = [];
  routerPath: number;
  cartProduct = [];
  productCount:number = 1;



  constructor(private shoopingService: ShoopingService, private spinnerService: NgxSpinnerService,
    private dataShareService: DataShareService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute, private notifyService : NotificationService) {
      this.route.params.subscribe(res => {
        this.routerPath = res['id'];
      })
     };
     

  ngOnInit(): void {
    this.showSpinner();
    this.fetchProducts(this.routerPath);
    this.getFavProducts();
    this.getCartProducts();
    this.dataShareService.sendClickEvent();
  }

  getFavProducts() {
    this.favProduct = JSON.parse(localStorage.getItem('favProduct'));
  }

  getCartProducts() {
    let findCart = localStorage.getItem('cartProduct');
    if(!findCart) {
      localStorage.setItem('cartProduct',JSON.stringify([]));
    }
    this.cartProduct = JSON.parse(localStorage.getItem('cartProduct'));
  }

  fetchProducts(productId) {
    this.shoopingService.findProduct(productId).subscribe(res => {
      res.price = Math.floor(res.price);
      this.products = res;
    });
  }

  public showSpinner(): void {
    this.spinnerService.show();
  }

  addCart(product){
    product.count = this.productCount;
    this.checkCartProduct(product);
    localStorage.setItem('cartProduct', JSON.stringify(this.cartProduct));
    this.dataShareService.sendClickEvent();
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }

  checkCart(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id)
    if(!findProduct) {
      return 'Add to Cart';
    } else {
      return 'Product added in Cart'
    }
  }

  checkFavourite(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.cartProduct.push(product);
      this.showToasterSuccess('Product added in your cart list!');
    } else {
      let removeProduct = this.favProduct.filter(item => item.id !== product.id);
      this.favProduct = removeProduct;
      this.showToasterSuccess('Product removed in your cart list!');
    }
  }

  checkCartProduct(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id);
    if(!findProduct) {
      this.cartProduct.push(product);
      this.showToasterSuccess('Product added in your cart list!');
    } else {
      let findCount = this.cartProduct.find(item => item.id == product.id);
      if(findCount.count !== product.count) {
        let removeProduct = this.cartProduct.filter(item => item.id !== product.id);
        this.cartProduct = removeProduct;
        this.cartProduct.push(product);
        this.showToasterSuccess('Product count updated in your cart list!');
      } else {
        let removeProduct = this.cartProduct.filter(item => item.id !== product.id);
        this.cartProduct = removeProduct;
        this.showToasterSuccess('Product removed in your cart list!');
      }
    }
  }

  reduceCount() {
    if(this.productCount !== 0) {
      this.productCount--;
    } else{
      return;
    }
  }

  increaseCount() {
    this.productCount++;
  }
}
